import React, { useState, useEffect } from "react";
import { Box, Grid, TextField, Typography, Button, CircularProgress, InputAdornment } from "@mui/material";
import { Save } from "lucide-react";
import { useTranslation } from "react-i18next";
const PLATFORMS = [{
  key: "facebook",
  label: "Facebook",
  placeholder: "https://facebook.com/yourpage",
  icon: "📘"
}, {
  key: "instagram",
  label: "Instagram",
  placeholder: "https://instagram.com/yourhandle",
  icon: "📷"
}, {
  key: "twitter",
  label: "X (Twitter)",
  placeholder: "https://x.com/yourhandle",
  icon: "🐦"
}, {
  key: "tiktok",
  label: "TikTok",
  placeholder: "https://tiktok.com/@yourhandle",
  icon: "🎵"
}, {
  key: "youtube",
  label: "YouTube",
  placeholder: "https://youtube.com/@yourchannel",
  icon: "▶️"
}, {
  key: "linkedin",
  label: "LinkedIn",
  placeholder: "https://linkedin.com/company/...",
  icon: "💼"
}, {
  key: "snapchat",
  label: "Snapchat",
  placeholder: "https://snapchat.com/add/...",
  icon: "👻"
}, {
  key: "whatsapp",
  label: "WhatsApp (public link)",
  placeholder: "https://wa.me/966512345678",
  icon: "💬"
}, {
  key: "googleMaps",
  label: "Google Maps",
  placeholder: "https://maps.google.com/?q=...",
  icon: "📍"
}];
const SocialLinksTab = ({
  settings,
  save,
  saving
}) => {
  const {
    t
  } = useTranslation("website");
  const [form, setForm] = useState({});
  useEffect(() => {
    if (settings?.socialLinks) setForm({
      ...settings.socialLinks
    });
  }, [settings]);
  const set = (key, val) => setForm(f => ({
    ...f,
    [key]: val
  }));
  return <Box>
      <Typography variant="body2" color="text.secondary" sx={{
      mb: 3
    }}>{t("Add links to your social media profiles. These will appear in the website footer and contact page. Leave blank to hide.")}

      </Typography>

      <Grid container spacing={2}>
        {PLATFORMS.map(p => <Grid item xs={12} sm={6} key={p.key}>
            <TextField label={p.label} value={form[p.key] || ""} onChange={e => set(p.key, e.target.value)} fullWidth placeholder={p.placeholder} InputProps={{
          startAdornment: <InputAdornment position="start">{p.icon}</InputAdornment>
        }} />
          
          </Grid>)}

        <Grid item xs={12}>
          <Button variant="contained" onClick={() => save({
          socialLinks: form
        })} disabled={saving} startIcon={saving ? <CircularProgress size={16} /> : <Save size={16} />}>{t("Save Social Links")}


          </Button>
        </Grid>
      </Grid>
    </Box>;
};
export default SocialLinksTab;
